import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class PostRecruitmentService {
  // 发布招聘-获取编辑招聘需求所需标签
  queryTags(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/getLabel',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-根据部门id获取岗位和面试官信息
  postInformation(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/interviewer',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-根据部门id和初试官id获取复试官
  postInverviewer(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/getSecondInverviewer',
      type: 'get',
      data: params,
      loading: true,
    });
  }

  // 发布招聘-保存发布招聘
  saveIssue(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/editRecruit',
      type: 'post',
      data: params,
      loading: true,
    });
  }

  // 发布招聘-发布招聘-获取招聘列表
  getRecruit(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/getRecruit',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-获取招聘详情
  getRecruitInfo(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/getRecruitInfo',
      type: 'get',
      data: params,
      loading: true,
    });
  }

  // 发布招聘-邀约
  getInvitationLabel(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getInvitationLabel',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-修改分配查询
  getHeadHunting(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getHeadHunting',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-修改分配
  distribution(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/distribution',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-邀约录入
  editInvitation(params: any, complate?: () => void): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/editInvitation',
      type: 'post',
      data: params,
      loading: true,
      complate,
    });
  }
  // 发布招聘-获取面试官日程安排
  getScheduleByInterviewerUid(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getScheduleByInterviewerUid',
      type: 'get',
      data: params,
      loading: true,
    });
  }

  // 面试邀约-列表
  getInvitationLists(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getInvitationLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 面试邀约-列表 异常列表
  getInvitationNonStandardLists(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getInvitationNonStandardLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 面试邀约-获取回访所需标签
  getReturnVisitLabel(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getReturnVisitLabel',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 面试邀约-获取复约相关标签
  getRetestInterviewer(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getRetestInterviewer',
      type: 'get',
      data: params,
      loading: true,
    });
  }

  // 回访-添加邀约回访
  editReturnVisit(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/editReturnVisit',
      type: 'post',
      data: params,
      loading: true,
    });
  }

  // 回访-面试邀约-根据面试官UID获取未安排面试的面试日程
  getInterviewerUid(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getScheduleByInterviewerUid',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-修改招聘状态
  updateStatus(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/updateStatus',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 发布招聘-查询相同手机号
  getIdenticalMobileLists(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getIdenticalMobileLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 获取公司列表
  getCompanyList(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'offer/getCompanyList',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 获取组织架构
  getOrgan(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'organ/get',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 邀约列表-更改为无效
  updateIneffectivenessStatus(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/updateIneffectivenessStatus',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 邀约列表-更改分配邀约
  updateInvitationUid(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/updateInvitationUid',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 邀约列表-检查当前邀约记录是否已经有他人开始面试
  startInterviewerCheck(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/startInterviewerCheck',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 回访  获取当前面试官提交的与入职相关信息
  getPreEntryJobInfo(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getPreEntryJobInfo',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 判断当前选择的面试官中是否有不可删除的
  checkInterviewer(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'recruit/checkInterviewer',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  constructor(public commonService: CommonService) {}
}
